import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ToleranceDetailsDialogData {
    sources: { name: string; column: string; recordCount: number; total: number }[];
    variance: number;
    failingFields: { name: string; tolerance: number; exceededBy: number }[];
}

@Component({
    selector: 'app-tolerance-details-dialog',
    templateUrl: './tolerance-details-dialog.component.html',
    styleUrls: ['./tolerance-details-dialog.component.scss'],
    standalone: false,
})
export class ToleranceDetailsDialogComponent {
    public absoluteVariance: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: ToleranceDetailsDialogData) {
        this.absoluteVariance = Math.abs(data.variance);
    }
}
